<template>
    <b-link id="btn-target-edit" href="#" :disabled="!canDoEdit" @click="editTarget(target.id)">
        <span :id="disableEditTargetAction">
            <p class="mb-0" style="font-size: 15px">
                <icon-edit />
            </p>
            <p class="mb-0">
                <small>{{ $t('form.button.edit') }}</small>
            </p>
            <b-tooltip :target="disableEditTargetAction" v-if="!canDoEdit">
                {{ viewEditTargetTooltipMessage }}
            </b-tooltip>
        </span>
    </b-link>
</template>

<script>
import { IconEdit } from '@/views/icons'

export default {
    name: 'EditTargetButton',
    components: {
        IconEdit,
    },
    props: {
        target: {
            type: Object,
            required: true,
        },
        currentEventPermissions: {
            type: Object,
            required: true,
        },
    },
    computed: {
        canDoEdit() {
            return this.currentEventPermissions[this.target.level].edit
        },
        disableEditTargetAction() {
            return 'disable-edit-target-action' + this.target.id
        },
        viewEditTargetTooltipMessage() {
            return (
                this.$t('profile.targetsTable.userWithoutPermissionEditTarget', {
                    stageTitle: this.target.owner.stages.current.title,
                }) + this.viewStageCriteriaMessage
            )
        },
        viewStageCriteriaMessage() {
            const firstEntryCriteria = 0
            if (!this.hasEntryCriteria) {
                return ''
            }
            const criterionIdentifier =
                this.target.owner.stages.current.entryCriteria[firstEntryCriteria].criterion.identifier
            return this.$t(`stages.eventHasCriteriaMessages.${criterionIdentifier}`)
        },
        hasEntryCriteria() {
            return Object.keys(this.target.owner.stages.current.entryCriteria).length
        },
    },
    methods: {
        editTarget(id) {
            if (!this.canDoEdit) {
                return this.showSwal(
                    this.$t('notification.permissions.editDenied', {
                        item: this.$t('targets.target'),
                    })
                )
            }
            this.$router.push(`/v2/target/targets/edit/${id}`)
            return
        },
    },
}
</script>
<style lang="scss" scoped>
#btn-target-edit.disabled {
    color: #6e6e6e;
    cursor: not-allowed;
    opacity: 1;
    text-decoration: none;
}
#btn-target-edit svg {
    fill: #009bda;
}
#btn-target-edit.disabled svg {
    fill: #6e6e6e;
}
</style>
